import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_75gfjzdxd9: FaireBrandEntity = {
  token: "b_75gfjzdxd9",
  type: "brand",
  name: "Happily Plants",
  avatarUrl:
    "https://cdn.faire.com/fastly/c2b3165376c423610490fed29ef7f2feec8e76ecf53ede571a3ea289461194e8.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c769c2a05aa6c8afcd5382a5218648601e32cb7111fd37695d7dc0a9b4ed2aa1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c2b3165376c423610490fed29ef7f2feec8e76ecf53ede571a3ea289461194e8.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c769c2a05aa6c8afcd5382a5218648601e32cb7111fd37695d7dc0a9b4ed2aa1.jpeg",
  location: "Westfield, NJ, USA",
  rating: 5,
  reviewCount: 73,
  isTopShop: true,
  isInsider: true,
  description:
    "The story of Happily Plants begins with its owner and principal designer, Heidi. Her career has spanned both fine art and commercial product design, working independently and with large retail brands in New York.\n\nHeidi spent her childhood surrounded by lush tropical plants, learning how to care for, propagate, and truly appreciate them. That early connection to the natural world stayed with her, eventually inspiring the launch of Happily Plants in 2018 as an online plant shop rooted in joy, beauty, and accessibility.\n\nAs the brand grew, Heidi began blending her design background with her love of the natural world. Drawing inspiration from plants and animals, she expanded Happily Plants into a thoughtfully designed collection of accessories and small goods—pieces that are playful, beautifully crafted, and meant to bring a little happiness into everyday life.\n\nToday, Happily Plants continues to evolve, extending its branches beyond plants while staying grounded in the same creative spirit. Each creation is beautifully crafted with intention, celebrating nature, color, and the simple joys that make life feel a bit more magical. At its heart, Happily Plants is about finding happiness in the details—and sharing that happiness with others.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:28:14.246Z",
    importedBy: "entity-db-cli",
  },
};
